import { gql } from "graphql-request";
import * as z from "zod";
import { Image, ImageFragment } from "./image";
import { Sys, SysFragment } from "./sys";
import { CommunityCreator, CommunityCreatorFragment } from "./communityCreator";
import { Locale } from "../../locale";

export const CommunityEntry = z.object({
  sys: Sys,
  communityCreator: CommunityCreator.nullish(),
  communityEntryTitle: z.string().nullable(),
  communityEntryVideoUrl: z.string().nullable(),
  communityEntryNewUntil: z.string().nullable(),
  communityEntryVideoLocale: Locale.nullable(),
  communityEntrySubmissionInfo: z.string().nullable(),
  communityEntryVideoThumbnail: Image.nullable(),
  communityEntryVideoThumbnailEn: Image.nullable(),
  sortDate: z.string().nullable(),
});

export type CommunityEntry = z.infer<typeof CommunityEntry>;

export const CommunityEntryFragment = gql`
  fragment CommunityEntryFragment on CommunityVideoEntry {
    sys {
      ...SysFragment
    }
    communityEntryTitle
    communityEntryVideoUrl
    communityEntryNewUntil
    communityEntryVideoLocale
    communityEntrySubmissionInfo
    communityEntryVideoThumbnail {
      ...ImageFragment
    }
    communityEntryVideoThumbnailEn: communityEntryVideoThumbnail(locale: "en") {
      ...ImageFragment
    }
    sortDate
    communityCreator {
      ...CommunityCreatorFragment
    }
  }

  ${CommunityCreatorFragment}
  ${ImageFragment}
  ${SysFragment}
`;
